module.exports = __webpack_public_path__ + "static/media/loader.ba210266.gif";